<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-4-josef">
<h1>Chapter 4<br/> Josef</h1>
<p>A small boy, Josef, is giggling. “Daddy, come find me.”</p>
<p>Bjorn calls back, “I can hear you. Keep calling.”</p>
<p>“Keep calling out to Daddy,” calls Zorn.</p>
<p>Josef responds, “I’m over here, Daddy. Come find me.”</p>
<p>A rumble is heard and a small meteor breaks into the atmosphere.</p>
<p>Bjorn calls out in a panic, “Josef, run to Daddy, now.”</p>
<p>“What’s wrong?” cries Josef.</p>
<p>Bjorn, even more panicked, yells, “Another meteor coming in.”</p>
<p>Josef appears from out of the bushes and is struck in the head. Josef melts into a ball of fluid. Zorn runs to Josef, reanimates him and picks the body up. Bjorn runs into the house behind them. Bjorn places his hand on Josef’s head and it glows. He attempts to reanimate Josef’s body but it won’t hold its shape. It convulses and melts. He is gone.</p>
<p>“I can’t help him. I can’t help him,” cries Bjorn, now distraught.</p>
<p>Zorn has tears pouring down his face. He takes Bjorn’s hand. “Let him go.”</p>
<p>They hold hands and meld together, absorbing Josef’s body. They remain as one. A pool of glowing fluid.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?73d21145